import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { P as PopoverContainer } from '../Popover/PopoverContainer-DUYc_Bvx.js';
import { T as TooltipContentContainer } from './TooltipContent-CrJjF8Ug.js';
import { I as InteractiveContainer } from './InteractiveContainer-f4XoCR7s.js';
import { N as NonInteractiveContainer } from './NonInteractiveContainer-zEdKekJ3.js';
import { T as TRIGGER_MESSAGE_ID, D as DEFAULT_TRANSITION_DURATION } from './constants-DsghXWMj.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const Tooltip = props => {
  const {
    align = 'center',
    children,
    closeButtonLabel = 'Close Tooltip',
    closeButtonPosition = 'default',
    disablePortal = false,
    footer,
    forceOpen = false,
    inert = false,
    message = '',
    nonInteractive = false,
    onClick,
    onCloseButtonClick = noop,
    position = 'top',
    spacing = 7,
    transitionDuration = DEFAULT_TRANSITION_DURATION,
    trigger,
    fullWidthTrigger,
    variant = 'default',
    withCloseButton: externalWithCloseButton = true,
    ...rest
  } = props;
  const Container = nonInteractive ? NonInteractiveContainer : InteractiveContainer;
  const messageId = nonInteractive ? TRIGGER_MESSAGE_ID : undefined;
  return /*#__PURE__*/React__default.createElement(Container, {
    align: align,
    forceOpen: forceOpen,
    inert: inert,
    onClick: onClick,
    onCloseButtonClick: onCloseButtonClick,
    position: position,
    spacing: spacing,
    transitionDuration: transitionDuration,
    trigger: trigger,
    fullWidthTrigger: fullWidthTrigger,
    triggerAriaDescribedby: messageId,
    withCloseButton: externalWithCloseButton
  }, ({
    handleCloseClicked,
    withCloseButton,
    ...popoverProps
  }) => /*#__PURE__*/React__default.createElement(PopoverContainer, _extends({}, rest, popoverProps, {
    disablePortal: disablePortal,
    position: position,
    popoverType: "tooltip",
    variant: variant
  }), /*#__PURE__*/React__default.createElement(TooltipContentContainer, {
    closeButtonLabel: closeButtonLabel,
    closeIconPosition: closeButtonPosition,
    footer: footer,
    handleCloseClicked: handleCloseClicked,
    message: message,
    messageId: messageId,
    withCloseButton: withCloseButton
  }, children)));
};

export { Tooltip as T };
//# sourceMappingURL=Tooltip-BFsMGm0r.js.map
